import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	smartFieldsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	smartFieldsLabel: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.smartfields-dropdown-item.smart-fields-label',
		defaultMessage: 'Hide unused fields',
		description: 'Label for hide unused fields menu item in issue-create modal header',
	},
});
export default messages;
